module.exports = __webpack_public_path__ + "static/media/cyan-marker.613368c3.svg";